module.exports = __webpack_public_path__ + "img/arrows-collapse.d6b13e57.svg";